import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './screens/home/home.component';


const routes: Routes = [
  {path:'', component:HomeComponent, pathMatch: 'full'},
  {
    path: '',
    loadChildren: () =>
      import('./lazy-menu/lazy-menu.module').then((m) => m.LazyMenuModule), 
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
